// extracted by mini-css-extract-plugin
module.exports = {"msgA":"msgA_msgA__3PZ5a"};